<template>
  <v-row>
    <v-col cols="12">
      <v-expansion-panels flat v-model="panel">
        <v-expansion-panel class="grey lighten-4">
          <!-- HEADER -->
          <v-expansion-panel-header>
            <v-row dense>
              <v-col cols="12">
                <span class="font-weight-bold">
                  <v-icon left small color="black"
                    >mdi-image-multiple-outline</v-icon
                  >
                  Imagens registradas
                  <small class="ml-1 font-weight-medium">
                    ({{ imagens().length }}
                    {{ imagens().length > 1 ? "imagens" : "imagem" }})
                  </small>
                </span>
              </v-col>
              <v-col cols="12">
                <small class="grey--text text--darken-2"
                  >(Mín: {{ configImg().min_docs }} | Máx:
                  {{ configImg().max_docs }})</small
                >
              </v-col>
            </v-row>
          </v-expansion-panel-header>

          <!-- CONTENT -->
          <v-expansion-panel-content>
            <v-row dense>
              <!-- IMAGEM -->
              <v-col md="4" cols="6" v-for="(imagem, i) in imagens()" :key="i">
                <v-card
                  rounded="lg"
                  outlined
                  class="img-card"
                  @click="abrirPreview(imagem)"
                >
                  <div class="img-wrapper">
                    <v-img
                      :src="imagem.thumb_url"
                      aspect-ratio="1"
                      height="130"
                      class="rounded-lg grey lighten-3"
                      alt="Imagem registrada"
                    >
                      <template v-slot:placeholder>
                        <v-skeleton-loader
                          type="image"
                          class="rounded-lg"
                          height="130"
                        />
                      </template>
                    </v-img>

                    <!-- AÇÕES: aparecem no hover (desktop) e sempre no mobile -->
                    <div
                      class="overlay-actions"
                      :class="{ 'overlay-actions--show': isMobile() }"
                    >
                      <!-- <v-btn
                        icon
                        small
                        color="white"
                        class="mr-1"
                        title="Visualizar"
                        @click.stop="abrirPreview(imagem)"
                        v-if="!isMobile()"
                      >
                        <v-icon>mdi-magnify-plus</v-icon>
                      </v-btn> -->
                      <v-btn
                        icon
                        small
                        color="white"
                        title="Remover"
                        @click.stop="removerImg(imagem)"
                      >
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-card>
              </v-col>

              <!-- ADICIONAR -->
              <v-col
                md="4"
                cols="6"
                v-if="imagens().length < configImg().max_docs"
              >
                <v-card
                  outlined
                  class="d-flex flex-column align-center justify-center dashed-tile"
                  role="button"
                  tabindex="0"
                  @click="abrirEscolhaFonte"
                  @keyup.enter.space.prevent="abrirEscolhaFonte"
                  aria-label="Adicionar foto"
                >
                  <v-icon size="36">mdi-camera</v-icon>
                  <div class="mt-2 caption">Adicionar foto</div>
                </v-card>
                <!-- inputs escondidos -->
                <input
                  ref="fileCam"
                  type="file"
                  accept="image/*"
                  capture="environment"
                  class="d-none"
                  @change="onPick"
                />
                <input
                  ref="fileGal"
                  type="file"
                  accept="image/*"
                  class="d-none"
                  @change="onPick"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>

    <!--- Selecione fonte da imagem/documento -->
    <v-bottom-sheet v-model="escolherFonteOpen">
      <v-list>
        <v-subheader class="grey--text text--darken-1"
          >Adicionar imagem</v-subheader
        >
        <v-list-item @click="escolherFonte('camera')" ripple>
          <v-list-item-action><v-icon>mdi-camera</v-icon></v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold"
              >Câmera</v-list-item-title
            >
            <v-list-item-subtitle>Tirar uma foto agora</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="escolherFonte('galeria')" ripple>
          <v-list-item-action
            ><v-icon>mdi-image-multiple-outline</v-icon></v-list-item-action
          >
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold"
              >Galeria</v-list-item-title
            >
            <v-list-item-subtitle>Selecionar da galeria</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider />
        <v-list-item @click="escolherFonteOpen = false">
          <v-list-item-action><v-icon>mdi-close</v-icon></v-list-item-action>
          <v-list-item-title>Cancelar</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-bottom-sheet>
  </v-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { toBase64 } from "@/global";
import Vue from "vue";
import { comprimirImagem } from "@/global";

export default {
  props: {
    categoria: { Type: String, required: true }, // mantido como está
  },
  watch: {
    "$route.query.addimg"(val) {
      this.escolherFonteOpen = val === "1";
    },
  },
  computed: {
    ...mapState("visitaTecnica", ["visita", "configuracoes", "output_doc"]),
  },
  data: () => ({
    panel: 0,
    escolherFonteOpen: false,
  }),
  methods: {
    ...mapActions("visitaTecnica", [
      "buscarDocumento",
      "buscarDocsVisitaDB",
      "abrirPreview",
    ]),
    isMobile() {
      return this.$mq == "sm";
    },
    // abre o bottom sheet
    abrirEscolhaFonte() {
      if (this.configImg().somente_camera) {
        this.$refs.fileCam.click();
      } else {
        const q = { ...(this.$route.query || {}), addimg: "1" };
        this.$router
          .push({
            name: this.$route.name,
            params: this.$route.params,
            query: q,
          })
          .catch(() => {});
        this.escolherFonteOpen = true;
      }
    },

    fecharSheet() {
      this.escolherFonteOpen = false;
      if (this.$route.query.addimg) {
        this.$router.back(); // remove ?addimg=1
      }
    },
    onSheetToggle(open) {
      if (!open && this.$route.query.addimg) {
        this.$router.back();
      }
    },
    escolherFonte(origem) {
      this.fecharSheet();
      if (origem === "camera") this.$refs.fileCam.click();
      else this.$refs.fileGal.click();
    },
    abrirCamera() {
      this.$refs.fileCam.click();
    },
    async onPick(e) {
      // tua lógica existente
      const file = e.target.files[0];
      if (!file) return;

      // 1) Imagem Full
      const imagemComprimida = await comprimirImagem(file);
      const base64 = await toBase64(imagemComprimida);
      const docUrl = URL.createObjectURL(imagemComprimida);

      // 2) THUMB pra listagem
      const imgThumbBlob = await comprimirImagem(file, 400, 400, 0.7);
      const base64_thumb = await toBase64(imgThumbBlob);
      const thumbUrl = URL.createObjectURL(imgThumbBlob);

      this.visita.docs.push({
        id: 0,
        id_visita: this.visita.id,
        categoria: this.categoria,
        documento: base64,
        doc_url: docUrl,
        thumbnail: base64_thumb,
        thumb_url: thumbUrl,
        remover: false,
        mime_type: "image/jpeg",
        criado_offline: false,
      });
      e.target.value = "";
    },
    removerImg(value) {
      const pos =
        value.id > 0
          ? this.visita.docs.findIndex((d) => d.id == value.id)
          : this.visita.docs.findIndex((d) => d.thumb_url == value.thumb_url);

      if (pos >= 0) {
        //this.visita.docs[pos].remover = true;
        if (value.id > 0) Vue.set(this.visita.docs[pos], "remover", true);
        else this.visita.docs.splice(pos, 1);
      }
    },
    configImg() {
      return this.configuracoes.dados.imagens_config.find(
        (ic) => ic.categoria.toLowerCase() == this.categoria
      );
    },
    imagens() {
      return this.visita.docs.filter(
        (d) => d.categoria.toLowerCase() == this.categoria && !d.remover
      );
    },
  },
  destroyed() {
    for (const key in this.visita.docs) {
      if (this.visita.docs[key].remover) {
        this.visita.docs[key].remover = false;
      } else if (
        this.visita.docs[key].id == 0 &&
        !this.visita.docs[key].criado_offline
      ) {
        this.visita.docs.splice(key, 1);
      }
    }
  },
  async mounted() {
    for (const img of this.imagens()) {
      await this.buscarDocsVisitaDB(img);
    }
  },
};
</script>

<style scoped>
.img-card {
  transition: box-shadow 0.2s ease;
}
.img-card:hover {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.img-wrapper {
  position: relative;
}
.overlay-actions {
  position: absolute;
  top: 6px;
  right: 6px;
  display: none;
  align-items: center;
  background: rgba(0, 0, 0, 0.35);
  padding: 4px 6px;
  border-radius: 999px;
}
.img-wrapper:hover .overlay-actions {
  display: inline-flex;
}
.overlay-actions--show {
  display: inline-flex;
} /* mobile: sempre visível */

.dashed-tile {
  border-style: dashed;
  min-height: 130px;
}
</style>
